import { ActionTree } from 'vuex'
import * as types from './mutation-types'
import RootState from '@vue-storefront/core/types/RootState'
import ConfigsState from '../../types/ConfigsState'
import { processURLAddress } from '@vue-storefront/core/helpers'
import fetch from 'isomorphic-fetch'
import config from 'config'
import rootStore from '@vue-storefront/core/store'

const actions: ActionTree<ConfigsState, RootState> = {
  loadConfigs ({commit}) {
    let url = processURLAddress(`${config.configs.base_endpoint}/list/configs`)
    return fetch(url, { method: config.elasticsearch.queryMethod,
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(resp => resp.json())
      .then(response => {
        commit(types.SET_CONFIGS, response.result)
        let allowedCountries = []
        let allowedCountriesConfig = JSON.parse(response.result.find(general => general.key === 'allowed_countries').value)
        allowedCountriesConfig.forEach(country => {
          allowedCountries.push({
            code: country.code,
            name: country.name
          })
        })
        commit(types.SET_ALLOWED_COUNTRIES, allowedCountries)

        return response
      })
      .catch(error => {
        throw new Error('FetchError in request to ES: ' + error.toString())
      })
  }
}

export default actions
